/**
 * @generated SignedSource<<a14a44b3fa89e476b3521499a6712daf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LoadInvoicesQuery$variables = {
  after?: string | null | undefined;
  block: number;
  first: number;
  orderBy?: string | null | undefined;
  schoolId?: string | null | undefined;
  searchTerm?: string | null | undefined;
  startingYear: number;
  status?: string | null | undefined;
};
export type LoadInvoicesQuery$data = {
  readonly me: {
    readonly profile: {
      readonly profileGroup: {
        readonly generateDraftsProgress: number | null | undefined;
        readonly id: string;
        readonly matchPaymentsProgress: number | null | undefined;
        readonly sendDraftsProgress: number | null | undefined;
        readonly sendRemindersProgress: number | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"InvoicingHeadlineDataFragment_query" | "LoadInvoices_query_invoices">;
};
export type LoadInvoicesQuery = {
  response: LoadInvoicesQuery$data;
  variables: LoadInvoicesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "block"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderBy"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "schoolId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchTerm"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startingYear"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "status"
},
v8 = {
  "kind": "Variable",
  "name": "block",
  "variableName": "block"
},
v9 = {
  "kind": "Variable",
  "name": "startingYear",
  "variableName": "startingYear"
},
v10 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  (v8/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "orderBy",
    "variableName": "orderBy"
  },
  {
    "kind": "Variable",
    "name": "schoolId",
    "variableName": "schoolId"
  },
  {
    "kind": "Variable",
    "name": "searchTerm",
    "variableName": "searchTerm"
  },
  (v9/*: any*/),
  {
    "kind": "Variable",
    "name": "status",
    "variableName": "status"
  }
],
v11 = [
  (v8/*: any*/),
  (v9/*: any*/)
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "ProfileGroupNode",
  "kind": "LinkedField",
  "name": "profileGroup",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "generateDraftsProgress",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sendDraftsProgress",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sendRemindersProgress",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "matchPaymentsProgress",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "LoadInvoicesQuery",
    "selections": [
      {
        "args": (v10/*: any*/),
        "kind": "FragmentSpread",
        "name": "LoadInvoices_query_invoices"
      },
      {
        "args": (v11/*: any*/),
        "kind": "FragmentSpread",
        "name": "InvoicingHeadlineDataFragment_query"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DjangoUserNode",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProfileNode",
            "kind": "LinkedField",
            "name": "profile",
            "plural": false,
            "selections": [
              (v13/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v1/*: any*/),
      (v7/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "LoadInvoicesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v10/*: any*/),
        "concreteType": "InvoiceNodeConnection",
        "kind": "LinkedField",
        "name": "invoices",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "InvoiceNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "InvoiceNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalAmount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isUpdate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProfileNode",
                    "kind": "LinkedField",
                    "name": "assignedTo",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "accountNumber",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "phoneNumber",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasInvalidPhoneNumber",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DjangoUserNode",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "email",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProfileNodeConnection",
                        "kind": "LinkedField",
                        "name": "children",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProfileNodeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProfileNode",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v12/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "DjangoUserNode",
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                      (v14/*: any*/),
                                      (v15/*: any*/),
                                      (v12/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "initialSentTimestamp",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "reminder1SentTimestamp",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "reminder2SentTimestamp",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "reminder3SentTimestamp",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v10/*: any*/),
        "filters": [
          "orderBy",
          "searchTerm",
          "startingYear",
          "block",
          "status",
          "schoolId"
        ],
        "handle": "connection",
        "key": "LoadInvoices_query_invoices",
        "kind": "LinkedHandle",
        "name": "invoices"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DjangoUserNode",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProfileNode",
            "kind": "LinkedField",
            "name": "profile",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              {
                "alias": null,
                "args": (v11/*: any*/),
                "kind": "ScalarField",
                "name": "totalInvoices",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v11/*: any*/),
                "kind": "ScalarField",
                "name": "totalAmountInvoiced",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v11/*: any*/),
                "kind": "ScalarField",
                "name": "totalInvoicesSent",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v11/*: any*/),
                "kind": "ScalarField",
                "name": "totalAmountPaid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v11/*: any*/),
                "kind": "ScalarField",
                "name": "totalInvoicesUnpaid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v11/*: any*/),
                "kind": "ScalarField",
                "name": "percentLessonBlocksInvoicedFor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v11/*: any*/),
                "concreteType": "LessonBlockNode",
                "kind": "LinkedField",
                "name": "lessonBlocksNotInvoicedFor",
                "plural": true,
                "selections": [
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SchoolNode",
                    "kind": "LinkedField",
                    "name": "school",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProfileNode",
                    "kind": "LinkedField",
                    "name": "pupil",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "schoolYear",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DjangoUserNode",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v13/*: any*/)
            ],
            "storageKey": null
          },
          (v12/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "009ffe1115724497294b1373ebb50b0a",
    "id": null,
    "metadata": {},
    "name": "LoadInvoicesQuery",
    "operationKind": "query",
    "text": "query LoadInvoicesQuery(\n  $orderBy: String\n  $searchTerm: String\n  $startingYear: Int!\n  $block: Int!\n  $status: String\n  $schoolId: ID\n  $first: Int!\n  $after: String\n) {\n  ...LoadInvoices_query_invoices_4yyjmd\n  ...InvoicingHeadlineDataFragment_query_UP0N6\n  me {\n    profile {\n      profileGroup {\n        id\n        generateDraftsProgress\n        sendDraftsProgress\n        sendRemindersProgress\n        matchPaymentsProgress\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment InvoicingHeadlineDataFragment_query_UP0N6 on Query {\n  me {\n    profile {\n      id\n      totalInvoices(startingYear: $startingYear, block: $block)\n      totalAmountInvoiced(startingYear: $startingYear, block: $block)\n      totalInvoicesSent(startingYear: $startingYear, block: $block)\n      totalAmountPaid(startingYear: $startingYear, block: $block)\n      totalInvoicesUnpaid(startingYear: $startingYear, block: $block)\n      percentLessonBlocksInvoicedFor(startingYear: $startingYear, block: $block)\n      lessonBlocksNotInvoicedFor(startingYear: $startingYear, block: $block) {\n        id\n        school {\n          name\n          id\n        }\n        pupil {\n          id\n          schoolYear\n          user {\n            id\n            firstName\n            lastName\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment LoadInvoices_query_invoices_4yyjmd on Query {\n  invoices(orderBy: $orderBy, searchTerm: $searchTerm, startingYear: $startingYear, block: $block, status: $status, schoolId: $schoolId, first: $first, after: $after) {\n    edges {\n      node {\n        id\n        status\n        totalAmount\n        isUpdate\n        assignedTo {\n          id\n          accountNumber\n          phoneNumber\n          hasInvalidPhoneNumber\n          user {\n            id\n            firstName\n            lastName\n            email\n          }\n          children {\n            edges {\n              node {\n                id\n                user {\n                  firstName\n                  lastName\n                  id\n                }\n              }\n            }\n          }\n        }\n        initialSentTimestamp\n        reminder1SentTimestamp\n        reminder2SentTimestamp\n        reminder3SentTimestamp\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fe33bbfa838d687008f0d9f465d31112";

export default node;
